import {getCurrentInstance, ref, reactive, onMounted, computed, watch, nextTick} from 'vue';

export const useColumnResize = ({props, emit}) => {
  // Variable
  const {proxy} = getCurrentInstance();
  const cursorX = ref(0);
  const widthx = ref(0);
  const sortStatus = ref(0);
  /**
   * Hàm thay đổi độ rộng cột
   * NCPHUOC 12/04/2022
   */
  const changeColumnResize = (col, metaData) => {
    const index = proxy.columnx.findIndex(x => x === col);
    const columnsResize = proxy.columnx.filter(x => x.dataField !== 'rowAction' && x.dataField !== 'rowState');
    // Nếu là cột cuối cùng thì bỏ qua
    if (index !== -1 && index < columnsResize.length - 1) {
      const column = proxy.columnx[index];

      column['width'] = metaData.width;
      column['minWidth'] = metaData.width;
      const lastColumn = columnsResize[columnsResize.length - 1];

      // Cột cuối chỉ cần để minwidth để tự resize
      if (lastColumn.width) {
        const width = lastColumn.width;
        lastColumn['minWidth'] = width;
        delete lastColumn['width'];
      }
    }

    if (col.lock) {
      proxy.$nextTick(() => {
        // sửa bug 34604 nhhoang1 30.08.2023
        // proxy.updateStickyOffset(true);
      });
    }
  };

  const styleWidth = computed(() => {
    const rs = {};

    if (props.col.minWidth) {
      rs.minWidth = props.col.minWidth + 'px';
    }

    if (props.col.width) {
      rs.width = props.col.width + 'px';
      rs.minWidth = props.col.width + 'px';
    }

    if (props.col.lock) {
      rs.left = (props.col.stickyOffset || 0) + 'px';
    }

    return rs;
  });

  watch(cursorX, newVal => {
    const offsetX = proxy.resizeX - newVal;
    if (proxy.defaultwidth - offsetX >= proxy.minWidthx) {
      widthx.value = proxy.defaultwidth - offsetX;
    } else {
      widthx.value = proxy.minWidthx;
    }

    // const metaData = {
    //   width: widthx.value,
    //   minWidth: widthx.value,
    // };
    const metaData = {
      width: widthx.value,
      minWidth: 10,
    };
    emit('changeColumnResize', props.col, metaData);
  });

  // Method
  const sortEvent = col => {
    if (props.col != col) {
      sortStatus.value = proxy.$ms.constant.SortStatus.none;
    }
  };
  const sort = e => {
    // khi event bị dừng thì không tiếp tục
    // tình huống click vào lock cột
    if (e.cancel) {
      return;
    }

    // Kiểm tra sortable trước khi thực hiện sort
    if (!props.col.sortable) {
      return;
    }

    // EventBusGlobal.$emit(GlobalEventName.sortEvent, props.col);
    sortStatus.value += 1;
    props.col.sortStatus = sortStatus.value;
    if (sortStatus.value > proxy.$ms.constant.SortStatus.desc) {
      // me.sortStatus = me.$ms.constant.SortStatus.none;
      // NMSINH: Nếu set none thì đối với các bảng có thiết lập sort lần đầu sẽ bị lỗi load lại 2 lần trạng thái asc
      sortStatus.value = proxy.$ms.constant.SortStatus.none;
      props.col.sortStatus = proxy.$ms.constant.SortStatus.none;
    }
    emit('sort', props.col, sortStatus.value);
  };

  // Bắt đầu co kéo cột
  const resizeOn = event => {
    nextTick(() => {
      proxy.defaultwidth = proxy.$el.offsetWidth;
      proxy.minWidthx = 0;
    });

    proxy.resizeX = event.screenX;
    emit('resizeOn', props.col);
    document.addEventListener('mousemove', mousemove);
    document.addEventListener('mouseup', resizeOff);
  };

  // Di chuyển co kéo cột
  const mousemove = e => {
    cursorX.value = e.screenX;
    if (!proxy.isResizeActive) {
      proxy.isResizeActive = true;
      // document.addEventListener('mouseup', resizeOff);
    }
  };

  // Ngừng co kéo cột
  const resizeOff = () => {
    emit('resizeOff', props.col);
    document.removeEventListener('mousemove', mousemove);
    closeResizeOff();
    proxy.isResizeActive = false;
  };

  const closeResizeOff = () => {
    document.removeEventListener('mouseup', resizeOff);
  };

  // Update lại động rộng của cột
  const updateColWidth = autoResize => {
    if (proxy.$el) {
      proxy.minWidth = props.col.width;
      Object.assign(props.col, {
        _width: proxy.$el.offsetWidth,
        autoResize: autoResize,
      });
    }
  };
  const stopEvent = e => {
    e.preventDefault();
    e.cancel = true;
  };
  /**
   * click update lock cột
   */
  const lockClick = e => {
    // stop event để không raise tiếp event sort
    stopEvent(e);
    emit('changeLock', props.col, !props.col.lock);
  };

  const handlerResizeOn = currentCol => {
    //VDDONG 24/01/2024: Do table màn hình tùy chỉnh mẫu là tự custom không có columnx gán lại columnx theo col
    //Không ảnh hưởng đến các màn hình dùng các base grid khác
    if(!proxy.columnx) {
      proxy.columnx = proxy.col;
    }
    const columnsResize = proxy.columnx.filter(x => x.dataField !== 'rowAction' && x.dataField !== 'rowState');

    if (columnsResize.length > 0) {
      const colIndex = columnsResize.length - 1;
      for (let index = 0; index < colIndex; index++) {
        const col = proxy.columnx[index];
        if (!col.width) {
          const $el = proxy.$refs['th'][index]?.$el;
          if ($el && $el.offsetWidth) {
            col.width = $el.offsetWidth;
          }
        }
      }
    }
  };

  return {
    changeColumnResize,
    closeResizeOff,
    resizeOff,
    mousemove,
    resizeOn,
    sort,
    sortEvent,
    cursorX,
    widthx,
    sortStatus,
    styleWidth,
    lockClick,
    handlerResizeOn,
  };
};
